import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-dialog-fullscreen-header',
  templateUrl: './dialog-fullscreen-header.component.html',
  styleUrls: ['./dialog-fullscreen-header.component.scss']
})
export class DialogFullscreenHeaderComponent implements OnInit {
  @Input()
  heading: string;
  @Input()
  disableClose = false;
  @Output()
  onClose = new EventEmitter();
  closeListener: boolean = false;

  constructor() { }

  ngOnInit() {
    this.closeListener = this.onClose.observers.length !== 0;
  }

  close() {
    this.onClose.emit();
  }
}
